<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Consulta de Solicitudes de Carta de no Adeudo" description="" />
      <NoDebtCertificateRequested/>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header/Header.vue'
import NoDebtCertificateRequested from '@/components/NoDebtCertificate/NoDebtCertificateRequested.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'

export default {
  data() {
    return {}
  },
  name: 'NoDebtCertificateRequestedView',
  components: {
    NoDebtCertificateRequested,
    Header,
    Logo
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>